// Importa a instância de i18n do SynoroPackages
import { i18nConfig } from '@sysmobil/synoro-packages';

import pt_BR from './languages/pt-BR.json';
import es from './languages/es.json';

// Adiciona as traduções do seuClube à instância compartilhada do i18n
// usando um namespace separado 'app' para evitar conflitos com 'synoro'
const addSeuClubeTranslations = () => {
  const languages = [
    { code: 'pt-BR', data: pt_BR },
    { code: 'es', data: es },
  ];

  languages.forEach(({ code, data }) => {
    // Adiciona namespace 'app' para traduções do seuClube
    i18nConfig.addResourceBundle(code, 'app', data, true, true);
  });
};

// Adiciona as traduções quando o módulo é importado
addSeuClubeTranslations();

// Exporta a instância compartilhada
export default i18nConfig;
